import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import { Row, Trip } from '../../interfaces';
import { HeaderCells } from '../../types/ui';

export const headerCells: HeaderCells = [
  { id: 'city', label: 'City' },
  { id: 'state', label: 'State' },
  { id: 'startDateTime', label: 'Start Date' },
  { id: 'endDateTime', label: 'End Date' },
];

// Function to create a table row from trip data
function createRow(trip: Trip) {
  const row = {
    rowId: trip.tripId,
    cells: [
      <Typography variant="body1">{trip.city}</Typography>,
      <Typography variant="body1">{trip.state}</Typography>,
      <Typography variant="body1">
        {format(new Date(trip.startDateTime), 'MM/dd/yyyy')}
      </Typography>,
      <Typography variant="body1">
        {format(new Date(trip.endDateTime), 'MM/dd/yyyy')}
      </Typography>,
    ],
  };

  return row;
}

// Function to create filtered rows based on appointment status
export function createRows({ items }: { items: Trip[] | undefined }) {
  if (!items) {
    return [];
  }

  const rows: Row[] = [];
  items.forEach(item => {
    rows.push(createRow(item));
  });
  return rows;
}
